<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter1" id="pgepubid00006">
<h2 class="c4">PRACTICAL ASTROLOGY, &amp;c.</h2>
</div>
<p class="c10">By the word Astrology (derived from the Greek <span xml:lang="grc">αστηρ</span>, <em class="calibre12">a star</em>, and <span xml:lang="grc">λογος</span>, <em class="calibre12">a discourse</em>,) is meant
the art of prognosticating or foretelling events<a id="r8"></a><span class="c12" href="#/Text/Section0044#f8" title="Link target outside of Sample"><sup class="calibre13">[8]</sup></span> by
the <span class="sc">Aspects</span>, <span class="sc">Positions</span>, and <span class="sc">Influence</span> of
the HEAVENLY BODIES.</p>
<p class="c11">By <span class="sc">Aspect</span> is to be understood an angle formed
by the rays of two planets meeting on earth, able
to execute some natural power or influence; which
may be better explained by the following table.</p>
<table class="table1" summary="">
<tbody class="calibre10"><tr class="calibre11"><td class="c15" colspan="4"><span id="Page_26" title="26"></span></td>
</tr>
<tr class="calibre11"><th class="c16" colspan="4"><span class="xlarge">CHARACTERS OF THE</span></th>
</tr>
<tr class="calibre11">
<td class="bbtd"> </td>
<td class="bbtd"> </td>
<td class="bbtd"> </td>
<td class="bbtd1"> </td>
</tr>
<tr class="calibre11">
<td class="bbt"><em class="calibre12">Six Northern Signs.</em></td>
<td class="bbt"><em class="calibre12">Six Southern Signs.</em></td>
<td class="bbt"><em class="calibre12">Planets.</em></td>
<td class="bbt1"><em class="calibre12">Aspects.</em></td>
</tr>
<tr class="calibre11">
<td class="brt">♈︎ Aries.</td>
<td class="brt">♎︎ Libra.</td>
<td class="brt">♄ Saturn.</td>
<td class="c17">☌ Conjunction.</td>
</tr>
<tr class="calibre11">
<td class="brt">♉︎ Taurus.</td>
<td class="brt">♏︎ Scorpio.</td>
<td class="brt">♃ Jupiter.</td>
<td class="c17">⚹ Sextile.</td>
</tr>
<tr class="calibre11">
<td class="brt">♊︎ Gemini.</td>
<td class="brt">♐︎ Sagittarius.</td>
<td class="brt">♂ Mars.</td>
<td class="c17">Δ Trine.</td>
</tr>
<tr class="calibre11">
<td class="brt">♋︎ Cancer.</td>
<td class="brt">♑︎ Capricorn.</td>
<td class="brt">☉ Sun.</td>
<td class="c17">☐ Quartile.</td>
</tr>
<tr class="calibre11">
<td class="brt">♌︎ Leo.</td>
<td class="brt">♒︎ Aquarius.</td>
<td class="brt">⦵ Earth.</td>
<td class="c17">☍ Opposition.</td>
</tr>
<tr class="calibre11">
<td class="brt">♍︎ Virgo.</td>
<td class="brt">♓︎ Pisces.</td>
<td class="brt">♀ Venus.</td>
<td class="c17"> </td>
</tr>
<tr class="calibre11">
<td class="brt"> </td>
<td class="brt"> </td>
<td class="brt">☿ Mercury.</td>
<td class="c17"> </td>
</tr>
<tr class="calibre11">
<td class="bbtd"> </td>
<td class="bbtd"> </td>
<td class="bbtd">☽ Luna.</td>
<td class="bbtd1"> </td>
</tr>
</tbody>
</table>
<p class="c11">This art, or rather this conjectural science, is
principally divided into <span class="sc">Natural</span> and <span class="sc">Judiciary</span>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?553d37f7